/**
 * Plans v2 local caps for API data count across ALL the user's own local
 * workspaces (as boards and documents count across scopes), not only the open
 * one. The other workspaces live in snapshots on disk; reading them needs the
 * workspace store router (filesystem, git), which must stay out of the MCP
 * import graph.
 *
 * So this file holds only a slot: the UI (plans/localApiUsage.js) registers
 * the counter, and the MCP write path (mcp/collectionsDb.js) asks it. Imports
 * nothing. Unregistered (no UI loaded, e.g. a unit test of the MCP path alone)
 * the other workspaces count as zero; what the open one holds still counts.
 */

export const NO_API_ITEMS = Object.freeze({ collections: 0, requests: 0, environments: 0 });

let counter = null;

/** `fn()` resolves `{ collections, requests, environments }` of the OTHER own local workspaces. */
export function registerOtherLocalApiCounter(fn) {
  counter = typeof fn === 'function' ? fn : null;
}

/**
 * The other own local workspaces' counts. The counter reads each workspace on
 * its own and counts one it cannot read as empty (a git workspace whose folder
 * is gone must not block every create for good), so this never rejects.
 */
export async function otherLocalApiCounts() {
  if (!counter) return NO_API_ITEMS;
  try {
    const counts = await counter();
    return counts && typeof counts === 'object' ? { ...NO_API_ITEMS, ...counts } : NO_API_ITEMS;
  } catch {
    return NO_API_ITEMS;
  }
}
